/**
 * Centralized query-key factory for the Focused Lead View.
 *
 * Using a factory keeps keys consistent between `useQuery` callers,
 * `queryClient.setQueryData` writes (see `useNextLead`), and
 * `queryClient.invalidateQueries` calls (see `useSkipLead`,
 * `useSaveCallOutcome`).
 */
export const queryKeys = {
	focusedView: {
		all: ['focused-view'] as const,
		lead: (companyId: string | undefined) => ['focused-view', 'lead', companyId] as const,
		contacts: (companyId: string | undefined) => ['focused-view', 'contacts', companyId] as const,
		pacing: () => ['focused-view', 'pacing'] as const,
		outcomes: (companyId: string | undefined) => ['focused-view', 'outcomes', companyId] as const,
		skipReasons: (companyId: string | undefined) => ['focused-view', 'skip-reasons', companyId] as const,
		phoneCall: (phoneCallId: string | undefined) => ['focused-view', 'phone-call', phoneCallId] as const,
		phoneCallsByCompany: (companyId: string | undefined) =>
			['focused-view', 'phone-calls', 'by-company', companyId] as const,
		transcription: (transcriptionId: string | undefined) => ['focused-view', 'transcription', transcriptionId] as const,
		dealForm: (companyId: string | undefined, dealId?: string) =>
			['focused-view', 'deal-form', companyId, dealId ?? 'create'] as const,
	},
} as const;
